import { PaginationConfig } from '@front-app/hooks/usePagination';
import { NoteMessage, ReadStatus } from '@front-app/services/NoteApi/NoteModels';

const PAGE_SIZE = 6;

export const getFirstPagePaginationConfig = (messages: NoteMessage[]): PaginationConfig => {
	const firstUnreadPostIdx = messages
		.findIndex(({ readStatus }) => readStatus === ReadStatus.UNREAD);

	// Fall back to just show the end of the messages, if they are all read
	if (firstUnreadPostIdx === -1) {
		const endIdx = getEndIdx(Infinity, messages.length);
		return {
			startIdx: Math.max(endIdx - (PAGE_SIZE - 1), 0),
			endIdx,
		};
	}

	const startIdx = getStartIdx(firstUnreadPostIdx);
	const endIdx = getEndIdx(startIdx, messages.length);
	return {
		startIdx,
		endIdx,
	};
};

export const getDeeplinkPaginationConfig = (
	messages: NoteMessage[],
	deeplinkedMessageId: string,
): PaginationConfig => {
	const deeplinkedMessageIdx = messages
		.findIndex(({ noteMessageId }) => noteMessageId === deeplinkedMessageId);

	if (deeplinkedMessageIdx === -1) {
		return getFirstPagePaginationConfig(messages);
	}

	const startIdx = getStartIdx(deeplinkedMessageIdx);

	return {
		startIdx,
		endIdx: getEndIdx(startIdx, messages.length),
	};
};

function getStartIdx(targetIdx: number): number {
	return Math.max(targetIdx - 2, 0);
}

function getEndIdx(startIdx: number, numMessages: number): number {
	return Math.min(startIdx + (PAGE_SIZE - 1), numMessages - 1);
}
